package one.healthium.paywall.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultPaywallComponent(
    componentContext: ComponentContext,
    override val paywallId: String?,
    override val onboardingId: String?,
    private val onPaywallPassed: () -> Unit,
    private val onSignInClicked: () -> Unit,
) : PaywallComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onPaywallPassed() {
        onPaywallPassed.invoke()
    }

    override fun onSignInClicked() {
        onSignInClicked.invoke()
    }
}
